import ImgAccessDenied from "../../assets/images/access_denied.png";
import { THEME_COLOR } from "./../../config/config";

export default function AccessDenied() {
  return (
    <div className="nk-body bg-white npc-general pg-error">
      <div className="nk-app-root">
        <div className="nk-main ">
          <div className="nk-wrap justify-center">
            <div className="nk-content ">
              <div className="nk-block nk-block-middle wide-md mx-auto">
                <div className="nk-block-content nk-error-ld text-center">
                  <img
                    className="nk-error-gfx"
                    src={ImgAccessDenied}
                    alt=""
                    style={{ height: "300px", height: "300px" }}
                  />
                  <div className="wide-xs mx-auto">
                    <h3 className="nk-error-title">Access Denied!</h3>
                    <p className="nk-error-text">
                      We apologize, but you do not have permission to access
                      this page.
                    </p>
                    <a
                      href="/"
                      className="btn btn-lg mt-2"
                      style={{ backgroundColor: THEME_COLOR, color: "white" }}
                    >
                      Back To Home
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
